<template>
  <div class="mTabMain">
    <div class="mTabDisplay">
      <Tabulator class="mTabTable" :tableTitle.sync="tableTitle" :tableID.sync="tableID" :tableData.sync="tableData" :multiSelect.sync="multiSelect" 
        :frozenColumn.sync="frozenColumn" :additionalColumn.sync="additionalColumn" @cellButtonClick="cellButtonClick" @rowSelected="rowSelected" />

      <div class="mTabLoadMain" v-if="mtLoad">
        <div class="mTabLoad">Getting Data</div>
      </div>

      <div class="mTabPopUpMain" v-if="mtPopUp">
        <div class="mTabPopUp">
          <Delivery v-if="(mtPage == 'DeliveryPage')" :title="(tableTitle.replace(/List/g, '')).trim()" :data.sync="mtSelectedRow" @mtClose="closeClick"/>
          <PendingCollection v-if="(mtPage == 'PendingCollectionPage')" :title="(tableTitle.replace(/List/g, '')).trim()" :data.sync="mtSelectedRow" @mtClose="closeClick"/>
          <Collection v-if="(mtPage == 'CollectionPage')" :title="(tableTitle.replace(/List/g, '')).trim()" :data.sync="mtSelectedRow" @mtClose="closeClick"/>
          <StagingDelivery v-if="(mtPage == 'StagingDeliveryPage')" :title="(tableTitle.replace(/List/g, '')).trim()" :data.sync="mtSelectedRow" @mtClose="closeClick"/>
          <StagingCollection v-if="(mtPage == 'StagingCollectionPage')" :title="(tableTitle.replace(/List/g, '')).trim()" :data.sync="mtSelectedRow" @mtClose="closeClick"/>
          <StagingInternalDiversion1 v-if="(mtPage == 'StagingInternalDiversion1Page')" :title="(tableTitle.replace(/List/g, '')).trim()" :data.sync="mtSelectedRow" @mtClose="closeClick"/>
          <StagingInternalDiversion2 v-if="(mtPage == 'StagingInternalDiversion2Page')" :title="(tableTitle.replace(/List/g, '')).trim()" :data.sync="mtSelectedRow" @mtClose="closeClick"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Tabulator from '@/components/Tabulator.vue';

//-------- Pages
import Delivery from '@/components/VehicleTracker/Pages/DeliveryPage.vue';
import PendingCollection from '@/components/VehicleTracker/Pages/PendingCollectionPage.vue';
import Collection from '@/components/VehicleTracker/Pages/CollectionPage.vue';
import StagingDelivery from '@/components/VehicleTracker/Pages/StagingDeliveryPage.vue';
import StagingCollection from '@/components/VehicleTracker/Pages/StagingCollectionPage.vue';
import StagingInternalDiversion1 from '@/components/VehicleTracker/Pages/StagingInternalDiversion1Page.vue';
import StagingInternalDiversion2 from '@/components/VehicleTracker/Pages/StagingInternalDiversion2Page.vue';

  export default {
    components: {
      Tabulator, 
      //-------- Pages Components
      Delivery, PendingCollection, Collection, StagingDelivery, StagingCollection, StagingInternalDiversion1, StagingInternalDiversion2,
    },
    props: {
      //-------- Mini Tab Props
      mtLoad: { type: Boolean, default: false },
      mtPopUp: { type: Boolean, default: false },
      mtPage: { type: String, default: '' },
      mtSelectedRow: { type: Array, default: function () { return []; }},

      //-------- Tabulator Props
      tableID: { type: String, default: 'miniTab' },
      tableTitle: { type: String, default: 'Mini Table' },
      multiSelect: { type: Number, default: -1 },
      tableData: { type: Array, default: function () { return []; }},
      frozenColumn: { type: Array, default: function () { return []; }},
      additionalColumn: { type: Array, default: function () { return []; }},
    },
    mounted() {
    },
    methods: {
      //-------- MiniTab Methods
      closeClick: function (title) {
        this.$emit('mtClose', title);
      },
      //-------- Tabulator Methods
      rowSelected: function (row) {
        this.$emit('rowSelected', row);
      },
      cellButtonClick: function (btn, row) {
        this.$emit('cellButtonClick', { btn: btn, row: row });
      },
    },
    watch: {

    },
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.mTabMain {
  width: 100%;
  height: 100%;
  min-width: 500px;
}

.mTabDisplay {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mTabTable{
  width: auto;
  height: auto;
  position: absolute;
  top: 0px;
  bottom: 35px;
  left: 2px;
  right: 2px;
}

.mTabLoadMain {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0008;
  z-index: 2;
}

.mTabLoad {
  width: 200px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 4px;
}

.mTabPopUpMain {
  width: 100%;
  height: 100%;
  padding: 10px 20px;
  position: absolute;
  top: 0px;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0008;
  z-index: 1;
}

.mTabPopUp {
  width: 100%;
  height: 100%;
  min-width: 300px;
  max-width: 800px;
  max-height: 300px;
  background-color: #fff;
  border-radius: 4px;
}
</style>